export default {
  duration_ms: null,
  webm_fix_successful: false,
  bytes_written: 0,
  expected_bytes_written: 0,
};
